// @flow

import PropTypes from 'prop-types';
import styled from 'styled-components';

import type { Shift, UpdateShiftActionCreator, SignOutActionCreator } from '../../typings';
import AnimatedRow from '../Forms/AnimatedRow';
import ButtonContainer from '../Forms/ButtonContainer';
import FormContainer from '../Forms/FormContainer';
import FormScreenContainer from '../ui/FormScreenContainer';
import PaddedContainer from '../ui/PaddedContainer';
import Button from '../Button';

import ShiftBox from './ShiftBox';

const FormFieldsContainer = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
`;

const Link = styled.a`
  width: 100%;
  cursor: pointer;

  &:hover {
    opacity: 0.8;
  }
`;

const ShiftRow = styled(AnimatedRow)`
  padding: 0;
  margin: 28px 0;
  align-items: center;
`;

type Props = {
  shifts: Array<Shift>,
  updateShift: UpdateShiftActionCreator,
  signOut: SignOutActionCreator
};

export default function MultiShiftFields({ shifts, updateShift, signOut }: Props) {
  return (
    <FormScreenContainer>
      <FormContainer>
        <FormFieldsContainer>
          <PaddedContainer>{generateMultipleShiftsPanel(shifts, updateShift)}</PaddedContainer>

          <PaddedContainer>
            <ButtonContainer delay={0.6 + 0.2 * shifts.length}>
              <Button label="Cancel" buttonTheme="grey" onPress={signOut} withMargin />
            </ButtonContainer>
          </PaddedContainer>
        </FormFieldsContainer>
      </FormContainer>
    </FormScreenContainer>
  );
}

function generateMultipleShiftsPanel(shifts: Array<Shift>, updateShift: UpdateShiftActionCreator) {
  return shifts.map((shift, index) => (
    <ShiftRow key={shift.id} delay={0.4 + 0.2 * (index + 1)}>
      <Link onClick={handleClick(updateShift, shift)}>
        <ShiftBox shift={shift} />
      </Link>
    </ShiftRow>
  ));
}

function handleClick(updateShift: UpdateShiftActionCreator, shift: Shift) {
  return (e: MouseEvent) => {
    e.preventDefault();
    if (shift) {
      return updateShift(shift);
    }
    return null;
  };
}

MultiShiftFields.propTypes = {
  shifts: PropTypes.array,
  personas: PropTypes.array,
  updateShift: PropTypes.func,
  signOut: PropTypes.func
};
